import { render, staticRenderFns } from "./ManageFabricationsModal.vue?vue&type=template&id=aa702418&scoped=true"
import script from "./ManageFabricationsModal.vue?vue&type=script&lang=js"
export * from "./ManageFabricationsModal.vue?vue&type=script&lang=js"
import style0 from "./ManageFabricationsModal.vue?vue&type=style&index=0&id=aa702418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa702418",
  null
  
)

export default component.exports